export default {
    BOARD: 'board'
}
